interface IFormHead {
  heading: string;
}
const FormHead = ({ heading }: IFormHead) => {
  return (
    <div className="col-12">
      <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
        {heading}
      </h4>
    </div>
  );
};
export default FormHead;
